import { Trip } from './../classes.js';

//map icons
const shadow_primary = '/system/app/lib/img/pin_primary.png'
const shadow_purple = '/system/app/lib/img/pin_purple.png'
const shadow_blue = '/system/app/lib/img/pin_blue.png'
const shadow_grey = '/system/app/lib/img/pin_grey.png'
const shadow_orange = '/system/app/lib/img/pin_orange.png'

let custom_attributes = {
	html: `
			<div class="jaxbend_marker">
				<img class="jaxbend_marker__shadow" src="/system/app/lib/img/pin_grey.png">
				<img class="jaxbend_marker__icon" src="/system/app/lib/img/search.png">
			</div>
		`,
	
	iconSize: [40, 58],
	iconAnchor: [20, 58],
	popupAnchor: [0, -60],
};

export let search_icon = L.divIcon({
	html: `
			<div class="jaxbend_marker">
				<img class="jaxbend_marker__shadow" src="/system/app/lib/img/pin_grey.png">
				<img class="jaxbend_marker__icon" src="/system/app/lib/img/search.png">
			</div>
		`,
	
	iconSize: [40, 58],
	iconAnchor: [20, 58],
	popupAnchor: [-3, -60],
});


export function get_marker_display(m){
	
	if(!isNaN(m.type) && m.type != null){
		let style = Trip.styles[m.type];
		let shadow = shadow_primary;
		
		switch(style.category){
			case 'outdoor':
				shadow = shadow_primary;
				break;
			case 'water':
				shadow = shadow_blue;
				break;
			case 'attraction':
				shadow = shadow_purple;
				break;
			case 'logistics':
				shadow = shadow_grey;
				break;
			case 'amenities':
				shadow = shadow_orange;
				break;
		}
		
		custom_attributes.html = `
			<div class="jaxbend_marker">
				<img class="jaxbend_marker__shadow" src="${shadow}">
				<img class="jaxbend_marker__icon" src="/system/app/lib/img/${style.icon}.png">
			</div>
		`;
	}
	
	return L.divIcon(custom_attributes);
}


export function get_marker_color(cat){
	let background = 'primary';
	
	switch(cat){
		case 'outdoor':
			background = 'primary';
			break;
		case 'water':
			background = 'secondary';
			break;
		case 'attraction':
			background = 'purple';
			break;
		case 'logistics':
			background = 'tertiary';
			break;
		case 'amenities':
			background = 'orange';
			break;
	}
	
	
	return background;
}